/* eslint-disable @next/next/no-img-element */
import React, { useEffect, useState } from 'react';

import slugify from 'react-slugify';
import Backend from '../../../utils/Backend';
import { formatPrice } from '../../../helper/vehicle_formatter';

import Loader from '../../Loader';
import LearnMoreButton from '../../LearnMoreButton';

import styles from './styles.module.scss'
import AddCar from '../../../public/assets/icons/add-car.svg'
import AddCarBoi from '../../../public/assets/nevo-boi/addCarBoi.svg'
import CloseIcon from '../../../public/assets/icons/close-greyer.svg'
import CloseIconBoi from '../../../public/assets/nevo-boi/close.svg'
import { useIsBoiWebsite } from "../../Context/WebsiteType";

interface iEVSelector {
  vehicle: any,
  onClick: () => void,
  onDelete: (vehicle: any) => void,
}

export default function EVSelector({ vehicle, onClick, onDelete }: iEVSelector) {
  const [image, setImage] = useState("")
  const isBoiWebsite = useIsBoiWebsite();

  useEffect(() => {
    if (vehicle) {
      setImage(Backend.getImage(vehicle, "28"))
    }
  }, [vehicle])

  const onDeleteClick = (e: any) => {
    e.preventDefault()
    e.stopPropagation()

    setImage("")
    onDelete(vehicle)
  }

  const openVehicleInNewTab = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    const { id, make, model } = vehicle
    const generatedURL = `/vehicle/${slugify(make)}/${slugify(model)}/${id}`;

    window.open(generatedURL, "_blank");
  }

  return (
    <div 
      className={`${isBoiWebsite ? styles.evCardBoi : styles.evCard} ${vehicle ? isBoiWebsite ? styles.vehicleContainerBoi : styles.vehicleContainer : styles.emptyContainer}`}
      onClick={onClick}
    >
      { vehicle ? (
        <div className={isBoiWebsite ? styles.vehicleContentBoi : styles.vehicleContent}>
          <div className={isBoiWebsite ? styles.closeHolderBoi : styles.closeHolder} onClick={onDeleteClick}>
            <img src={isBoiWebsite ? CloseIconBoi.src : CloseIcon.src} alt="remove vehicle icon"/>
          </div>
          
          <div className={isBoiWebsite ? styles.vehicleImageBoi : styles.vehicleImage} style={{ backgroundImage: `url(${image})` }}>
            { image === "" ? <Loader /> : <>&nbsp;</> }
          </div>

          <div className={isBoiWebsite ? styles.vehicleDetailsBoi : styles.vehicleDetails}>
            <p className={isBoiWebsite ? styles.vehicleTypeBoi : styles.vehicleType}>
              {
                vehicle.fuel_type === "BEV" ? "All-Electric" :
                vehicle.fuel_type === "PHEV" ? "Plug-in Hybrid" : vehicle.fuel_type
              }
            </p>
            <p className={isBoiWebsite ? styles.vehicleMakeBoi : styles.vehicleMake}>{vehicle.make}</p>
            <p className={isBoiWebsite ? styles.vehicleModelBoi : styles.vehicleModel}>{ vehicle.model }</p>
            <p className={isBoiWebsite ? styles.vehicleTrimBoi : styles.vehicleTrim}>{ vehicle.trim_level + " - " + formatPrice(vehicle.price) }</p>

            <LearnMoreButton 
              className={isBoiWebsite ? styles.learnMoreBtnBoi : styles.learnMoreBtn}
              onClick={openVehicleInNewTab}
            />
          </div>
        </div>
      ) 
      : 
        <img src={isBoiWebsite ? AddCarBoi.src : AddCar.src} alt="Big plus sign (indicates that you can add a vehicle)"/>
      }
    </div>
  )
};